<template>
	<div class="norm-data">
		<Loading
			class="norm-data__loading"
			:active="loading"/>

		<Datatable
			class="norm-data__table"
			:headers="headers"
			:rows="content"
			:keyFactory="keyFactory"/>

		<PaginationIndicator
			v-if="lastPage > 1"
			class="norm-data__paginator bottom"
			:page="page"
			:pageCount="lastPage"
			@pageChange="loadPage"/>
	</div>
</template>

<script>
	import Datatable from "@/components/Datatable"
	import PaginationIndicator from "@/components/PaginationIndicator"
	import VueTypes from "vue-types"
	import { get, call } from "vuex-pathify"
	import Loading from "vue-loading-overlay"
	import "vue-loading-overlay/dist/vue-loading.css"

	const vuex_module = "normData";

	export default {
		props: {
			name: VueTypes.string.isRequired,
			id: VueTypes.number.isRequired,
			index: VueTypes.number.isRequired,
		},
		components: {
			Datatable,
			PaginationIndicator,
			Loading,
		},
		computed: {
			...get(vuex_module, [
				"getLastPage",
				"getPage",
				"pageContent",
				"isLoading",
				"headers",
			]),
			loading(){
				return this.isLoading(this.index);
			},
			lastPage(){
				return this.getLastPage(this.index);
			},
			page(){
				return this.getPage(this.index);
			},
			content(){
				return this.pageContent(this.index);
			},
		},
		methods: {
			keyFactory(row){
				// return `${row.Norme}__${row["Diamètre"]}__${row.Pas}`;
				// return row["Diamètre"];
				return row.id;
			},
			...call(vuex_module, {
				__loadPage: "FETCH_PAGE",
				__loadNext: "LOAD_NEXT",
				__loadPrev: "LOAD_PREV",
			}),
			payload(page){
				return {
					vm: this,
					index: this.index,
					id: this.id,
					page,
				};
			},
			loadPage(page){
				return this.__loadPage(this.payload(page));
			},
			loadNext(page){
				return this.__loadNext(this.payload(page));
			},
			loadPrev(page){
				return this.__loadPrev(this.payload(page));
			},
		},
		mounted(){
			this.$nextTick(() => {
				this.loadPage(1);
			});
		},
	}
</script>

<style lang="scss" scoped>
	@use "~@scss/components/NormData" as *;
</style>